import { render } from "./TotalSales.vue?vue&type=template&id=7f6dbcfc"
import script from "./TotalSales.vue?vue&type=script&lang=js"
export * from "./TotalSales.vue?vue&type=script&lang=js"

import "./TotalSales.vue?vue&type=style&index=0&id=7f6dbcfc&lang=css"

import exportComponent from "D:\\Programming\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__